import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE = {
  name: 'Salihi Consulting Services',
  shortName: 'Salihi Consulting',
  url: 'https://salihiconsulting.com',
  defaultDescription:
    'Salihi Consulting Services delivers premium business, financial, compliance, institutional, technology and advisory solutions to governments, enterprises, NGOs and development partners across Somalia and East Africa.',
  ogImage: 'https://salihiconsulting.com/og-image.png',
  twitter: '@salihiconsult',
  locale: 'en_US',
};

export default function SEO({
  title,
  description,
  path,
  image,
  type = 'website',
  schema,
  keywords,
  noindex = false,
}) {
  const location = useLocation();
  const url = `${SITE.url}${path || location.pathname}`;
  const fullTitle = title ? `${title} | ${SITE.shortName}` : `${SITE.shortName} — Premium Consulting Firm`;
  const desc = description || SITE.defaultDescription;
  const ogImg = image || SITE.ogImage;

  return (
    <Helmet prioritizeSeoTags>
      {/* Primary */}
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      )}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImg} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content={SITE.locale} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={SITE.twitter} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImg} />

      {/* JSON-LD page-specific schema */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}

export { SITE };
